<template>
    <v-dialog v-model="isShowDialog" max-width="80%" @click:outside="closePopup">
      <v-card>
        <v-card-title>
          <span class="title">Comments</span>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
              <v-flex lg12>
                <div class="oee-chatbox">
                  <vue-perfect-scrollbar class="chat-history--scrollbar" ref="chat_scroll" :settings="scrollbar_settings">
                      <v-list two-line class="chat-history--list">
                          <template v-for="(item, index) in items">
                              <v-list-item class="chat-list" :key="item.id">
                                  <v-list-item-content>
                                      <v-list-item-subtitle v-html="getTitle(item.created_by, item.created_at)"></v-list-item-subtitle>
                                      <p v-if="item.media != 1">{{ item.body }}</p>
                                      <div v-else>
                                          <a :href="'/'+item.body" target="_blank">
                                            <img :src="'/'+item.body" class="attachment-img"/>
                                          </a>
                                      </div>  
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-btn icon>
                                      <v-icon medium @click="deleteItem(item.id)">delete</v-icon>
                                    </v-btn>
                                  </v-list-item-action>
                              </v-list-item>
                              <v-divider :key="`divider-${index}`" v-if="index < items.length - 1"></v-divider>
                          </template>
                      </v-list>
                  </vue-perfect-scrollbar>
                  <v-divider></v-divider>
                  <v-layout row wrap class="pt-2">
                      <v-flex lg10 md10 sm10 xs10 pt-0 pb-0>
                          <v-text-field class="sms-input" append-icon="fa-paper-plane" v-model="message" label="Nội dung tin nhắn" @click:append="onSendMessage" v-on:keyup.enter="onSendMessage" @paste="onPaste">
                              <v-icon slot="append-icon">fa-paper-plane</v-icon>
                          </v-text-field>
                      </v-flex>
                      <v-flex lg2 md2 sm2 xs2 pt-0 pb-0>
                          <image-uploader :preview="false" :maxWidth="3000" :maxHeight="3000" outputFormat="file" :className="['fileinput', { 'fileinput--loaded': hasImage }]" @input="addFile">
                              <label for="fileInput" slot="upload-label" dark class="sms-attach">
                                  <v-icon>fa-paperclip</v-icon>
                                  Gửi ảnh
                              </label>
                          </image-uploader>
                      </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1 white--text" @click="closePopup">Exit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import ImageUploader from 'vue-image-upload-resize';
import moment from "moment"
import configs from '@/configs'
import _ from "lodash";
import { mapState } from "vuex";
export default {
  name: "comment-popup",
  components: {
    VuePerfectScrollbar,
    ImageUploader
  },
  data() {
    return {
      isShowDialog: false,
      message: "",
      timer: "",
      selectedArea: 1,
      scrollbar_settings: {
          wheelPropagation: true
      },
      hasImage: false,
      uploadValue: 100,
      imageData: null
    };
  },
  props: ["dialogComment", "productId"],
  computed: {
    ...mapState({
      items: (state) => state.comments.all.data,
      total_rows: (state) => state.comments.all.total,
      loading: (state) => state.comments.loading,
      currentItem: (state) => state.comments.selected
    }),
    myName() {
      return this.$store.state.authentication.user.username;
    }
  },
  watch: {
    productId() {
      this.fetchData();
    },
    comments() {
      this.scrollToEnd();
    },
    dialogComment() {
      this.isShowDialog = this.dialogComment;
      if(this.dialogComment) {
        this.fetchData();
      }
    }
  },
  methods: {
    scrollToEnd() {
      setTimeout(() => {
          const container = this.$el.querySelector('.ps-container');
          container.scrollTop = container.scrollHeight;
      }, 0);
    },
    fetchData: _.debounce(function () {
        this.$store.dispatch("comments/getList", {filter: [{'column': 'product_id', 'value': this.productId, 'condition': 'equal'}]});
    }, 100, { 'leading': true, 'trailing': false }),
    onSendMessage() {
      if(this.message != "") {
        this.$store.dispatch("comments/setDetail", {
          data: {
            product_id: this.productId,
            body: this.message
          }
        });
        this.message = "";
        this.scrollToEnd();
      }
    },
    getTitle(user_name, send_time) {
      return "<span class='text--primary font-weight-bold'>"+user_name+"</span>: " + moment.parseZone(send_time).format("DD-MM-YYYY HH:mm:ss")
    },
    closePopup() {
      this.$emit("closePopup");
    },
    openItem(item) {
      this.$emit("chooseFile", item);
    },
    addFile(output) {
      if(this.uploadValue == 100) {
        this.uploadValue = 0;
        this.hasImage = true;
        this.imageData = output;
        this.onUpload();
      }
    },
    onUpload() {
      const arrFileType = this.imageData.name.split('.');
      const formData = new FormData();
      formData.append('comment_file', this.productId);
      formData.append('attach_file', this.imageData);
      formData.append('filename', this.imageData.name);
      const ext = arrFileType[arrFileType.length - 1];
      formData.append('extension', ext);
      this.$store.dispatch("files/upload_file", formData).then((ret) => {
        this.uploadValue=100;
        if(ret.status==200) {
          this.$store.dispatch("comments/setDetail", {
            data: {
              product_id: this.productId,
              body: ret.data.file_name,
              media: 1
            }
          });
        }
      });
    },
    onPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
              const imageFile = items[i].getAsFile();
              this.addFile(imageFile);
            }
        }
    },
    deleteItem(id) {
      this.$store.dispatch("comments/removeDetail", id);
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.fetchData);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("files/removeDetail", id);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.fetchData);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>

<style scoped>
.v-list--two-line .v-list__tile {
    height: auto !important;
    padding: 5px 0 5px 0;
}

.sms-dest {
    margin-left: 12px;
}

.sms-input {
    margin-left: 8px;
    margin-right: 12px;
}

.sms-align-right {
    text-align: right;
}
.sms-attach {
    margin-top: 22px;
    display: block;
    cursor: pointer;
    line-height: 30px;
}
.sms-attach:hover {
    border: 1px solid #b50808;
    border-radius: 4px;
}
.sms-private {
    background-color: #FFDDDD
}
.attachment-img {
    width: 128px;
    flex: 0;
}
.sms-align-right .attachment-img {
     margin-left: calc(100% - 128px)
}
</style>
